import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import TabPanel from '@material-ui/lab/TabPanel';

import UserDetails from './UserDetailsConnected';
import {UserTabs, HandleChange} from './UserTypes';

interface UserProps {
    currentTab: UserTabs;
    onHandleChange: HandleChange;
}

export default function User(props: UserProps) {
    const {
        currentTab,
        onHandleChange,
    } = props;
    return (
        <div>
            <TabContext value={currentTab}>
                <AppBar position="static">
                    <Tabs
                        value={currentTab}
                        onChange={onHandleChange}
                    >
                        <Tab
                            label={UserTabs.UserDetails}
                            value={UserTabs.UserDetails}
                        />
                    </Tabs>
                </AppBar>
                <TabPanel value={UserTabs.UserDetails}>
                    <UserDetails />
                </TabPanel>
            </TabContext>
        </div>
    );
}
